<div class="container">
    <div class="row justify-content-center">
        <div class="col-12 col-md-7">
            <div class="card shadow-sm">
                <div class="card-body text-center p-4">
                    <h1 class="mb-3">Tracking Information Unavailable</h1>
                    <p class="lead mb-3">
                        If you have just received a message and clicked the link, tracking will become available once
                        the engineer is on the move.
                    </p>
                    <p class="text-muted">
                        Please note: After the engineer has arrived, this link will no longer be active.
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>
